import { EventNames, TrackingEventTypes } from "@cinch-nx/shared-analytics";
export var handleButtonClick = function(path, trackEvent, useBrowserNavigation, routerPush) {
    trackEvent({
        eventName: "unauth-save-vehicle-event",
        type: TrackingEventTypes.ADOBE,
        data: {
            event: {
                name: EventNames.click,
                category: "auth-modal-".concat(path, "-button"),
                label: path,
                action: "auth-modal-".concat(path)
            }
        }
    });
    useBrowserNavigation ? window.location.assign("/".concat(path)) : routerPush("/".concat(path));
};
